import { render, staticRenderFns } from "./ModalSubirRecibos.vue?vue&type=template&id=96a5a5a2"
import script from "./ModalSubirRecibos.vue?vue&type=script&lang=js"
export * from "./ModalSubirRecibos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('96a5a5a2')) {
      api.createRecord('96a5a5a2', component.options)
    } else {
      api.reload('96a5a5a2', component.options)
    }
    module.hot.accept("./ModalSubirRecibos.vue?vue&type=template&id=96a5a5a2", function () {
      api.rerender('96a5a5a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/recibos/ModalSubirRecibos.vue"
export default component.exports